import { useSelector } from "react-redux";

const isFullAdmin = (user) => {
  const role = user?.roleName?.toLowerCase();
  return role === "admin" || user?.roleId == 1;
};

const useCan = () => {
  const user = useSelector((state) => state.user.userDetails);
  const permissions = useSelector((state) => state.permission?.permissions || []);
  // console.log(permissions);
  const can = (module, action = "view", subModule = null) => {
    if (isFullAdmin(user) || !module) return true;

    const moduleData = permissions?.find((p) => p.key === module);
    if (!moduleData) return false;

    if (subModule) {
      const subModuleData = moduleData?.subModules?.find((sm) => sm.key === subModule);
      if (!subModuleData) return false;
      const actionData = subModuleData?.actions?.find((a) => a.key === action);
      return actionData?.allowed === true;
    }

    const actionData = moduleData?.actions?.find((a) => a.key === action);
    return actionData?.allowed === true;
  };

  return can;
};

export default useCan;
